import { Injectable, Optional, Inject } from '@angular/core';
import { DataAccess } from './data-access.service';
import { CACHE_VALIDATION_TIME } from '../providers';
import { noProviderWarning } from '../../shared/exceptions';
import { now } from '../../shared/utils';



@Injectable()

export class BmCache {

  private runningRequests: object = {};
  private ramCache: object = {};
  constructor(
    @Optional() @Inject(CACHE_VALIDATION_TIME) private timeout: number,
    private dataAccess: DataAccess) {

      if (this.timeout === null) {
        noProviderWarning('CACHE_VALIDATION_TIME', 3600);
        this.timeout = 3600;
      }
    }


  /* ---------- Public API ---------- */

  public clear() {
    this.runningRequests = {};
    this.ramCache = {};
    localStorage.clear();
  }

  public execute(command: any , skipCache: boolean = false): Promise<any> {

    const key = JSON.stringify(command);

    return this.getRunningRequest(key) ||
    this.getFromRamCache(key, skipCache) ||
    this.getFormLocalStorage(key, skipCache) ||
    this.getFromBackend(command, key);

  }

  public async loadEnums(entity?: string | number, id?: number) {

    try {
      const {data} = await this.execute({ action: 'LoadBOEnums' });
      const enumNames = data[0];
      let items;

      switch (typeof entity) {
        case 'undefined':
          return data.slice(1);

        case 'number':
          items = data[entity + 1];
          break;

        case 'string':
          const targetIndex = enumNames.findIndex(item => item.enumName === entity);
          items = data[targetIndex + 1];
          break;
      }

      return id ? items.find(item => this.getId(item) === id) : items;


    } catch (error) {
      return [];
    }
  }



  /* ----- Private implementations ----- */


  private getRunningRequest(key: string): Promise<any> {
    if (key in this.runningRequests) {
      return this.runningRequests[key];
    }
  }

  private getFromRamCache(key: string, skip: boolean): Promise<any> {
    if (skip) {
      return;
    }

    if (key in this.ramCache && !this.isCacheExpired(this.ramCache[key])) {
      return this.ramCache[key];
    }
  }

  private getFormLocalStorage(key: string, skip: boolean): Promise<any> {
    if (skip) {
      return;
    }

    if (key in localStorage) {
      const result = JSON.parse(localStorage.getItem(key));
      if (!this.isCacheExpired(result)) {
        return this.ramCache[key] = Promise.resolve(result);
      }
    }
  }

  private getFromBackend(command: any, key: string): Promise<any> {

    const request = new Promise((resolve, reject) => {
      this.dataAccess.execute(null, command)
      .then(response => {
        localStorage.setItem(key, JSON.stringify({
          ...response,
          lastExecuteTime: now()
        }));

        this.ramCache[key] = Promise.resolve(response);
        resolve(response);
      })
      .catch(err => reject(err))
      .finally(() => delete this.runningRequests[key]);
    });

    return this.runningRequests[key] = request;

  }

  private isCacheExpired(actionCache: any): boolean {
    const diff = now() - actionCache.lastExecuteTime;
    return diff > this.timeout;
  }

  private getId(item: object): number {
    const idKey = Object.keys(item).find(key => key.startsWith('_'));
    return item[idKey];
  }

}
